/* eslint-disable no-undef */
import { render } from '@wordpress/element';
import App from './App';
import './index.scss';

if (document.getElementById('js-international-methodology')) {
	render(<App />, document.getElementById('js-international-methodology'));
}
